import { SellingCompanyReport } from 'tms-lib';
import { PurchaseDespatchItemInvoiceReport } from './purchase-despatch-item-invoice-report';
import { PurchaseDespatchProductReportInvoice } from './purchase-despatch-product-report-invoice';
import { PurchaseInvoiceDeliveryReport } from './purchase-invoice-delivery-report';
import { PurchaseInvoiceExtraReport } from './purchase-invoice-extra-report';
import { PurchaseInvoicePackSummaryReport } from './purchase-invoice-pack-summary-report';
import { PurchaseInvoiceQualitySummaryReport } from './purchase-invoice-quality-summary-report';

export interface PurchaseInvoiceReport {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  externalNoteNo: string;
  receivedDate: Date;
  supplierKey: string;
  supplierName: string;
  accountsRef: string;
  supplierInvoiceRef: string;
  supplierInvoiceEmail: string;
  supplierAddressMultiLine: string;
  deliveryAddressMultiLine: string;
  invoiceAddressMultiLine: string;
  shipperSupplier: string;
  paymentTerms: string;
  paymentDueDate: string;
  deliveryTerm: string;
  deliveryTermNotes: string;
  modeOfTransport: string;
  currencyCode: string;
  currencySymbol: string;
  notes: string;
  taxCode: string;
  taxRate: number;
  grossQuantity: number;
  nettQuantity: number;
  goodsValue: number;
  totalDeliveryValue: number;
  totalExtraValue: number;
  nettValue: number;
  taxValue: number;
  overallValue: number;
  bankAccountName: string;
  bankName: string;
  bankIBAN: string;
  bankSwift: string;
  bankAccount: string;
  bankSortCode: string;
  bankAddress: string;
  bankReference: string;
  bankNarrative: string;
  bankPayable: string;
  bankBIC: string;
  paymentTermsMessage: string;
  invoiceAddressee: string;
  deliveryAddressee: string;

  sellingCompany: SellingCompanyReport;
  purchaseDespatchItems: PurchaseDespatchItemInvoiceReport[];
  purchaseDespatchProducts: PurchaseDespatchProductReportInvoice[];
  purchaseInvoiceDeliveryItems: PurchaseInvoiceDeliveryReport[];
  purchaseInvoiceExtraItems: PurchaseInvoiceExtraReport[];
  purchasePackSummary: PurchaseInvoicePackSummaryReport[];
  purchaseInvoiceQualitySummary: PurchaseInvoiceQualitySummaryReport[];
}
